import PropTypes from 'prop-types';
import React from 'react';

import { NUM_MAX_LINKS } from 'app/constants/admin/browse/home';
import { navigationSectionShape, navigationSectionValidationShape } from 'app/shapes/admin/browse/home';
import EditorLinks from './shared/EditorLinks';

import './SectionEditorNavigation.scss';

const SectionEditorNavigation = ({ onChange, section: navigationSection, validation }) => {
  const { links, sectionId } = navigationSection;

  const editorLinksKey = `${sectionId}_EditorLinks`;

  const handleLinksChange = newLinks => {
    onChange({
      ...navigationSection,
      links: newLinks
    });
  };

  return (
    <div className="cp-admin-browse-home-section-editor-navigation">
      <p className="rules">A maximum of {NUM_MAX_LINKS} links can be added</p>
      <EditorLinks
        key={editorLinksKey}
        links={links}
        onChange={handleLinksChange}
        validation={validation.errorByAttribute.links}
      />
    </div>
  );
};

SectionEditorNavigation.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      links: {
        createLink: { isValid: true, errorByAttribute: { label: '', url: '' } }
      }
    }
  }
};

SectionEditorNavigation.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: navigationSectionShape.isRequired,
  validation: navigationSectionValidationShape
};

export default SectionEditorNavigation;
